export const adminTranslations: AdminTranslations = {
  en: {
  // Dashboard
  "admin.adminDashboard": "Admin Dashboard",
  "totalUsers": "Total Users",
  "activeUsers": "Active Users",
  "pendingRewards": "Pending Rewards",
  "totalSurveys": "Total Surveys",
  "totalWaterLogged": "Total Water Logged",
  "recentUsers": "Recent Users",
  "recentRewardRequests": "Recent Reward Requests",
  "noRecentUsers": "No recent users",
  "noRecentRewards": "No recent rewards",
  "sendMessage": "Send Message",
  "sending": "Sending...",
  "messageTitle": "Message Title",
  "message": "Message",
  "messagesSent": "Messages sent successfully",
  "errorSendingMessages": "Error sending messages",
  "selectUser": "Select User",
  "user": "User",
  "reward": "Reward",
  "status": "Status",
  "date": "Date",
  "sendMessageTo": "Send Message to {{name}}",
  "openSidebar": "Open sidebar",

  // User Management
  "userManagement": "User Management",
  "allUsers": "All Users",
  "searchUsers": "Search Users",
  "filterByCountry": "Filter by Country",
  "minPoints": "Min Points",
  "maxPoints": "Max Points",
  "sortBy": "Sort By",
  "selectAll": "Select All",
  "usersSelected": "users selected",
  "noUsersFound": "No users found",
  "noUsers": "No users",
  "name": "Name",
  "fullName": "Full Name",
  "email": "Email",
  "country": "Country",
  "points": "Points",
  "totalPoints": "Total Points",
  "waterVolume": "Water Volume",
  "joinedDate": "Joined Date",
  "actions": "Actions",
  "view": "View",
  "edit": "Edit",
  "delete": "Delete",
  "editUser": "Edit User",
  "deleteUser": "Delete User",
  "deleteUserConfirmation": "Are you sure you want to delete {{name}}? This action cannot be undone.",
  "userDetails": "User Details",
  "personalInfo": "Personal Information",
  "statistics": "Statistics",
  "rewardRequests": "Reward Requests",
  "completedSurveys": "Completed Surveys",
  "noRewardRequests": "No reward requests",
  "noCompletedSurveys": "No completed surveys",
  "userUpdated": "User updated successfully",
  "errorUpdatingUser": "Error updating user",
  "userDeleted": "User deleted successfully",
  "errorDeletingUser": "Error deleting user",
  "select": "Select",

  // Survey Management
  "surveyManagement": "Survey Management",
  "createSurvey": "Create Survey",
  "editSurvey": "Edit Survey",
  "noSurveys": "No surveys",
  "title": "Title",
  "description": "Description",
  "active": "Active",
  "inactive": "Inactive",
  "questions": "Questions",
  "addQuestion": "Add Question",
  "question": "Question",
  "questionText": "Question Text",
  "options": "Options",
  "addOption": "Add Option",
  "option": "Option",
  "required": "Required",
  "multipleChoice": "Multiple Choice",
  "text": "Text",
  "rating": "Rating",
  "boolean": "Yes/No",
  "surveyCreated": "Survey created successfully",
  "errorCreatingSurvey": "Error creating survey",
  "surveyUpdated": "Survey updated successfully",
  "errorUpdatingSurvey": "Error updating survey",
  "surveyDeleted": "Survey deleted successfully",
  "errorDeletingSurvey": "Error deleting survey",
  "responses": "Responses",
  "viewResponses": "View Responses",
  "downloadCSV": "Download CSV",
  "noResponses": "No responses yet",
  "anonymous": "Anonymous",

  // Reward Management
  "rewardManagement": "Reward Management",
  "createReward": "Create Reward",
  "editReward": "Edit Reward",
  "noRewards": "No rewards",
  "pointsRequired": "Points Required",
  "photo": "Photo",
  "uploadPhoto": "Upload Photo",
  "photoSelected": "Photo Selected",
  "messageTemplate": "Approval Message Template",
  "approvalMessagePlaceholder": "Message to send when approving reward request",
  "rewardCreated": "Reward created successfully",
  "errorCreatingReward": "Error creating reward",
  "rewardUpdated": "Reward updated successfully",
  "errorUpdatingReward": "Error updating reward",
  "rewardDeleted": "Reward deleted successfully",
  "errorDeletingReward": "Error deleting reward",

  // Advertisement Management
  "advertisementManagement": "Advertisement Management",
  "advertisements": "Advertisements",
  "createAdvertisement": "Create Advertisement",
  "editAdvertisement": "Edit Advertisement",
  "noAdvertisements": "No advertisements",
  "advertisement": "Advertisement",
  "period": "Period",
  "frequency": "Frequency",
  "duration": "Duration",
  "startDate": "Start Date",
  "endDate": "End Date",
  "minutes": "minutes",
  "seconds": "seconds",
  "everyXMinutes": "Every {{minutes}} minutes",
  "xSeconds": "{{seconds}} seconds",
  "advertisementCreated": "Advertisement created successfully",
  "errorCreatingAdvertisement": "Error creating advertisement",
  "advertisementUpdated": "Advertisement updated successfully",
  "errorUpdatingAdvertisement": "Error updating advertisement",
  "advertisementDeleted": "Advertisement deleted successfully",
  "errorDeletingAdvertisement": "Error deleting advertisement",

  // Partner Offers Management
  "partnerOfferManagement": "Partner Offer Management",
  "partnerOffers": "Partner Offers",
  "createPartnerOffer": "Create Partner Offer",
  "editPartnerOffer": "Edit Partner Offer",
  "noPartnerOffers": "No partner offers",
  "partnerOfferCreated": "Partner offer created successfully",
  "errorCreatingPartnerOffer": "Error creating partner offer",
  "partnerOfferUpdated": "Partner offer updated successfully",
  "errorUpdatingPartnerOffer": "Error updating partner offer",
  "partnerOfferDeleted": "Partner offer deleted successfully",
  "errorDeletingPartnerOffer": "Error deleting partner offer",

  // Common
  "save": "Save",
  "cancel": "Cancel",
  "close": "Close",
  "create": "Create",
  "update": "Update",
  "approve": "Approve",
  "reject": "Reject",
  "pending": "Pending",
  "approved": "Approved",
  "rejected": "Rejected",
  "translations": "Translations",
  "primaryLanguage": "Primary Language",
  "copyQuestionsStructure": "Copy Questions Structure",
  "errorFetchingData": "Error fetching data",
  "pleaseAllFields": "Please fill all required fields",
  "language": "Language",
  "allCountries": "All Countries",
  "targetCountries": "Target Countries",
  "selectCountries": "Select countries",
  "leaveEmptyForAllCountries": "Leave empty to make available in all countries",
  "surveys": "Surveys",
  "requestDate": "Request Date",
  "statusUpdated": "Status updated successfully",
  "errorUpdatingStatus": "Error updating status",
  "send": "Send",
  "errorFetchingRewards": "Error fetching rewards",
  "image": "Image",
  "uploadImage": "Upload Image",
  "imageSelected": "Image Selected",
  "imageRequired": "Image is required",
  "imageUrl": "Image URL"
},
  
fr: {
  // Dashboard
  "adminDashboard": "Tableau de Bord Admin",
  "totalUsers": "Total Utilisateurs",
  "activeUsers": "Utilisateurs Actifs",
  "pendingRewards": "Récompenses en Attente",
  "totalSurveys": "Total Sondages",
  "totalWaterLogged": "Total Eau Enregistrée",
  "recentUsers": "Utilisateurs Récents",
  "recentRewardRequests": "Demandes de Récompense Récentes",
  "noRecentUsers": "Aucun utilisateur récent",
  "noRecentRewards": "Aucune récompense récente",
  "sendMessage": "Envoyer Message",
  "sending": "Envoi en cours...",
  "messageTitle": "Titre du Message",
  "message": "Message",
  "messagesSent": "Messages envoyés avec succès",
  "errorSendingMessages": "Erreur lors de l'envoi des messages",
  "selectUser": "Sélectionner Utilisateur",
  "user": "Utilisateur",
  "reward": "Récompense",
  "status": "Statut",
  "date": "Date",
  "sendMessageTo": "Envoyer un message à {{name}}",
  "openSidebar": "Ouvrir le menu latéral",

  // User Management
  "userManagement": "Gestion des Utilisateurs",
  "allUsers": "Tous les Utilisateurs",
  "searchUsers": "Rechercher Utilisateurs",
  "filterByCountry": "Filtrer par Pays",
  "minPoints": "Points Min",
  "maxPoints": "Points Max",
  "sortBy": "Trier par",
  "selectAll": "Tout Sélectionner",
  "usersSelected": "utilisateurs sélectionnés",
  "noUsersFound": "Aucun utilisateur trouvé",
  "noUsers": "Aucun utilisateur",
  "name": "Nom",
  "fullName": "Nom Complet",
  "email": "Email",
  "country": "Pays",
  "points": "Points",
  "totalPoints": "Total des Points",
  "waterVolume": "Volume d'Eau",
  "joinedDate": "Date d'Inscription",
  "actions": "Actions",
  "view": "Voir",
  "edit": "Modifier",
  "delete": "Supprimer",
  "editUser": "Modifier Utilisateur",
  "deleteUser": "Supprimer Utilisateur",
  "deleteUserConfirmation": "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",
  "userDetails": "Détails Utilisateur",
  "personalInfo": "Informations Personnelles",
  "statistics": "Statistiques",
  "rewardRequests": "Demandes de Récompense",
  "completedSurveys": "Sondages Complétés",
  "noRewardRequests": "Aucune demande de récompense",
  "noCompletedSurveys": "Aucun sondage complété",
  "userUpdated": "Utilisateur mis à jour avec succès",
  "errorUpdatingUser": "Erreur lors de la mise à jour de l'utilisateur",
  "userDeleted": "Utilisateur supprimé avec succès",
  "errorDeletingUser": "Erreur lors de la suppression de l'utilisateur",
  "select": "Sélectionner",

  // Survey Management
  "surveyManagement": "Gestion des Sondages",
  "createSurvey": "Créer Sondage",
  "editSurvey": "Modifier Sondage",
  "noSurveys": "Aucun sondage",
  "title": "Titre",
  "description": "Description",
  "status": "Statut",
  "active": "Actif",
  "inactive": "Inactif",
  "questions": "Questions",
  "addQuestion": "Ajouter Question",
  "question": "Question",
  "questionText": "Texte de la Question",
  "options": "Options",
  "addOption": "Ajouter Option",
  "option": "Option",
  "required": "Obligatoire",
  "multipleChoice": "Choix Multiple",
  "text": "Texte",
  "rating": "Évaluation",
  "boolean": "Oui/Non",
  "surveyCreated": "Sondage créé avec succès",
  "errorCreatingSurvey": "Erreur lors de la création du sondage",
  "surveyUpdated": "Sondage mis à jour avec succès",
  "errorUpdatingSurvey": "Erreur lors de la mise à jour du sondage",
  "surveyDeleted": "Sondage supprimé avec succès",
  "errorDeletingSurvey": "Erreur lors de la suppression du sondage",
  "responses": "Réponses",
  "viewResponses": "Voir les Réponses",
  "downloadCSV": "Télécharger CSV",
  "noResponses": "Aucune réponse pour le moment",
  "anonymous": "Anonyme",

  // Reward Management
  "rewardManagement": "Gestion des Récompenses",
  "createReward": "Créer Récompense",
  "editReward": "Modifier Récompense",
  "noRewards": "Aucune récompense",
  "pointsRequired": "Points Requis",
  "photo": "Photo",
  "uploadPhoto": "Télécharger Photo",
  "photoSelected": "Photo Sélectionnée",
  "messageTemplate": "Modèle de Message d'Approbation",
  "approvalMessagePlaceholder": "Message à envoyer lors de l'approbation de la demande de récompense",
  "rewardCreated": "Récompense créée avec succès",
  "errorCreatingReward": "Erreur lors de la création de la récompense",
  "rewardUpdated": "Récompense mise à jour avec succès",
  "errorUpdatingReward": "Erreur lors de la mise à jour de la récompense",
  "rewardDeleted": "Récompense supprimée avec succès",
  "errorDeletingReward": "Erreur lors de la suppression de la récompense",

  // Advertisement Management
  "advertisementManagement": "Gestion des Publicités",
  "advertisements": "Publicités",
  "createAdvertisement": "Créer une Publicité",
  "editAdvertisement": "Modifier la Publicité",
  "noAdvertisements": "Aucune publicité",
  "advertisement": "Publicité",
  "period": "Période",
  "frequency": "Fréquence",
  "duration": "Durée",
  "startDate": "Date de Début",
  "endDate": "Date de Fin",
  "minutes": "minutes",
  "seconds": "secondes",
  "everyXMinutes": "Toutes les {{minutes}} minutes",
  "xSeconds": "{{seconds}} secondes",
  "advertisementCreated": "Publicité créée avec succès",
  "errorCreatingAdvertisement": "Erreur lors de la création de la publicité",
  "advertisementUpdated": "Publicité mise à jour avec succès",
  "errorUpdatingAdvertisement": "Erreur lors de la mise à jour de la publicité",
  "advertisementDeleted": "Publicité supprimée avec succès",
  "errorDeletingAdvertisement": "Erreur lors de la suppression de la publicité",

  // Partner Offers Management
  "partnerOfferManagement": "Gestion des Offres Partenaires",
  "partnerOffers": "Offres Partenaires",
  "createPartnerOffer": "Créer une Offre Partenaire",
  "editPartnerOffer": "Modifier l'Offre Partenaire",
  "noPartnerOffers": "Aucune offre partenaire",
  "partnerOfferCreated": "Offre partenaire créée avec succès",
  "errorCreatingPartnerOffer": "Erreur lors de la création de l'offre partenaire",
  "partnerOfferUpdated": "Offre partenaire mise à jour avec succès",
  "errorUpdatingPartnerOffer": "Erreur lors de la mise à jour de l'offre partenaire",
  "partnerOfferDeleted": "Offre partenaire supprimée avec succès",
  "errorDeletingPartnerOffer": "Erreur lors de la suppression de l'offre partenaire",

  // Common
  "save": "Enregistrer",
  "cancel": "Annuler",
  "close": "Fermer",
  "create": "Créer",
  "update": "Mettre à jour",
  "approve": "Approuver",
  "reject": "Rejeter",
  "pending": "En attente",
  "approved": "Approuvé",
  "rejected": "Rejeté",
  "translations": "Traductions",
  "primaryLanguage": "Langue Principale",
  "copyQuestionsStructure": "Copier la Structure des Questions",
  "errorFetchingData": "Erreur lors de la récupération des données",
  "pleaseAllFields": "Veuillez remplir tous les champs",
  "language": "Langue",
  "allCountries": "Tous les Pays",
  "targetCountries": "Pays cibles",
  "selectCountries": "Sélectionner les pays",
  "leaveEmptyForAllCountries": "Laissez vide pour rendre disponible dans tous les pays",
  "surveys": "Sondages",
  "requestDate": "Date de la Demande",
  "statusUpdated": "Statut mis à jour avec succès",
  "errorUpdatingStatus": "Erreur lors de la mise à jour du statut",
  "send": "Envoyer",
  "errorFetchingRewards": "Erreur lors de la récupération des récompenses",
  "image": "Image",
  "uploadImage": "Télécharger une Image",
  "imageSelected": "Image Sélectionnée",
  "imageRequired": "L'image est requise",
  "imageUrl": "URL de l'image"
},

  es: {
  // Dashboard
  "adminDashboard": "Panel de Administración",
  "totalUsers": "Total Usuarios",
  "activeUsers": "Usuarios Activos",
  "pendingRewards": "Recompensas Pendientes",
  "totalSurveys": "Total Encuestas",
  "totalWaterLogged": "Total Agua Registrada",
  "recentUsers": "Usuarios Recientes",
  "recentRewardRequests": "Solicitudes de Recompensa Recientes",
  "noRecentUsers": "No hay usuarios recientes",
  "noRecentRewards": "No hay recompensas recientes",
  "sendMessage": "Enviar Mensaje",
  "sending": "Enviando...",
  "messageTitle": "Título del Mensaje",
  "message": "Mensaje",
  "messagesSent": "Mensajes enviados con éxito",
  "errorSendingMessages": "Error al enviar mensajes",
  "selectUser": "Seleccionar Usuario",
  "user": "Usuario",
  "reward": "Recompensa",
  "status": "Estado",
  "date": "Fecha",
  "sendMessageTo": "Enviar mensaje a {{name}}",
  "openSidebar": "Abrir menú lateral",

  // User Management
  "userManagement": "Gestión de Usuarios",
  "allUsers": "Todos los Usuarios",
  "searchUsers": "Buscar Usuarios",
  "filterByCountry": "Filtrar por País",
  "minPoints": "Puntos Mín",
  "maxPoints": "Puntos Máx",
  "sortBy": "Ordenar por",
  "selectAll": "Seleccionar Todo",
  "usersSelected": "usuarios seleccionados",
  "noUsersFound": "No se encontraron usuarios",
  "noUsers": "No hay usuarios",
  "name": "Nombre",
  "fullName": "Nombre Completo",
  "email": "Email",
  "country": "País",
  "points": "Puntos",
  "totalPoints": "Total de Puntos",
  "waterVolume": "Volumen de Agua",
  "joinedDate": "Fecha de Registro",
  "actions": "Acciones",
  "view": "Ver",
  "edit": "Editar",
  "delete": "Eliminar",
  "editUser": "Editar Usuario",
  "deleteUser": "Eliminar Usuario",
  "deleteUserConfirmation": "¿Está seguro de que desea eliminar a {{name}}? Esta acción no se puede deshacer.",
  "userDetails": "Detalles del Usuario",
  "personalInfo": "Información Personal",
  "statistics": "Estadísticas",
  "rewardRequests": "Solicitudes de Recompensa",
  "completedSurveys": "Encuestas Completadas",
  "noRewardRequests": "No hay solicitudes de recompensa",
  "noCompletedSurveys": "No hay encuestas completadas",
  "userUpdated": "Usuario actualizado con éxito",
  "errorUpdatingUser": "Error al actualizar usuario",
  "userDeleted": "Usuario eliminado con éxito",
  "errorDeletingUser": "Error al eliminar usuario",
  "select": "Seleccionar",

  // Survey Management
  "surveyManagement": "Gestión de Encuestas",
  "createSurvey": "Crear Encuesta",
  "editSurvey": "Editar Encuesta",
  "noSurveys": "No hay encuestas",
  "title": "Título",
  "description": "Descripción",
  "status": "Estado",
  "active": "Activo",
  "inactive": "Inactivo",
  "questions": "Preguntas",
  "addQuestion": "Añadir Pregunta",
  "question": "Pregunta",
  "questionText": "Texto de la Pregunta",
  "options": "Opciones",
  "addOption": "Añadir Opción",
  "option": "Opción",
  "required": "Obligatorio",
  "multipleChoice": "Opción Múltiple",
  "text": "Texto",
  "rating": "Valoración",
  "boolean": "Sí/No",
  "surveyCreated": "Encuesta creada con éxito",
  "errorCreatingSurvey": "Error al crear encuesta",
  "surveyUpdated": "Encuesta actualizada con éxito",
  "errorUpdatingSurvey": "Error al actualizar encuesta",
  "surveyDeleted": "Encuesta eliminada con éxito",
  "errorDeletingSurvey": "Error al eliminar encuesta",
  "responses": "Respuestas",
  "viewResponses": "Ver Respuestas",
  "downloadCSV": "Descargar CSV",
  "noResponses": "No hay respuestas todavía",
  "anonymous": "Anónimo",

  // Reward Management
  "rewardManagement": "Gestión de Recompensas",
  "createReward": "Crear Recompensa",
  "editReward": "Editar Recompensa",
  "noRewards": "No hay recompensas",
  "pointsRequired": "Puntos Requeridos",
  "photo": "Foto",
  "uploadPhoto": "Subir Foto",
  "photoSelected": "Foto Seleccionada",
  "messageTemplate": "Plantilla de Mensaje de Aprobación",
  "approvalMessagePlaceholder": "Mensaje para enviar al aprobar la solicitud de recompensa",
  "rewardCreated": "Recompensa creada con éxito",
  "errorCreatingReward": "Error al crear recompensa",
  "rewardUpdated": "Recompensa actualizada con éxito",
  "errorUpdatingReward": "Error al actualizar recompensa",
  "rewardDeleted": "Recompensa eliminada con éxito",
  "errorDeletingReward": "Error al eliminar recompensa",

  // Advertisement Management
  "advertisementManagement": "Gestión de Anuncios",
  "advertisements": "Anuncios",
  "createAdvertisement": "Crear Anuncio",
  "editAdvertisement": "Editar Anuncio",
  "noAdvertisements": "No hay anuncios",
  "advertisement": "Anuncio",
  "period": "Período",
  "frequency": "Frecuencia",
  "duration": "Duración",
  "startDate": "Fecha de Inicio",
  "endDate": "Fecha de Fin",
  "minutes": "minutos",
  "seconds": "segundos",
  "everyXMinutes": "Cada {{minutes}} minutos",
  "xSeconds": "{{seconds}} segundos",
  "advertisementCreated": "Anuncio creado con éxito",
  "errorCreatingAdvertisement": "Error al crear anuncio",
  "advertisementUpdated": "Anuncio actualizado con éxito",
  "errorUpdatingAdvertisement": "Error al actualizar anuncio",
  "advertisementDeleted": "Anuncio eliminado con éxito",
  "errorDeletingAdvertisement": "Error al eliminar anuncio",

  // Partner Offers Management
  "partnerOfferManagement": "Gestión de Ofertas de Socios",
  "partnerOffers": "Ofertas de Socios",
  "createPartnerOffer": "Crear Oferta de Socio",
  "editPartnerOffer": "Editar Oferta de Socio",
  "noPartnerOffers": "No hay ofertas de socios",
  "partnerOfferCreated": "Oferta de socio creada con éxito",
  "errorCreatingPartnerOffer": "Error al crear oferta de socio",
  "partnerOfferUpdated": "Oferta de socio actualizada con éxito",
  "errorUpdatingPartnerOffer": "Error al actualizar oferta de socio",
  "partnerOfferDeleted": "Oferta de socio eliminada con éxito",
  "errorDeletingPartnerOffer": "Error al eliminar oferta de socio",

  // Common
  "save": "Guardar",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "create": "Crear",
  "update": "Actualizar",
  "approve": "Aprobar",
  "reject": "Rechazar",
  "pending": "Pendiente",
  "approved": "Aprobado",
  "rejected": "Rechazado",
  "translations": "Traducciones",
  "primaryLanguage": "Idioma Principal",
  "copyQuestionsStructure": "Copiar Estructura de Preguntas",
  "errorFetchingData": "Error al obtener datos",
  "pleaseAllFields": "Por favor complete todos los campos",
  "language": "Idioma",
  "allCountries": "Todos los Países",
  "targetCountries": "Países objetivo",
  "selectCountries": "Seleccionar países",
  "leaveEmptyForAllCountries": "Dejar vacío para hacer disponible en todos los países",
  "surveys": "Encuestas",
  "requestDate": "Fecha de Solicitud",
  "statusUpdated": "Estado actualizado con éxito",
  "errorUpdatingStatus": "Error al actualizar el estado",
  "send": "Enviar",
  "errorFetchingRewards": "Error al obtener recompensas",
  "image": "Imagen",
  "uploadImage": "Subir Imagen",
  "imageSelected": "Imagen Seleccionada",
  "imageRequired": "La imagen es requerida",
  "imageUrl": "URL de la imagen"
},

  pt: {
  // Dashboard
  "adminDashboard": "Painel de Administração",
  "totalUsers": "Total de Usuários",
  "activeUsers": "Usuários Ativos",
  "pendingRewards": "Recompensas Pendentes",
  "totalSurveys": "Total de Pesquisas",
  "totalWaterLogged": "Total de Água Registrada",
  "recentUsers": "Usuários Recentes",
  "recentRewardRequests": "Solicitações de Recompensa Recentes",
  "noRecentUsers": "Nenhum usuário recente",
  "noRecentRewards": "Nenhuma recompensa recente",
  "sendMessage": "Enviar Mensagem",
  "sending": "Enviando...",
  "messageTitle": "Título da Mensagem",
  "message": "Mensagem",
  "messagesSent": "Mensagens enviadas com sucesso",
  "errorSendingMessages": "Erro ao enviar mensagens",
  "selectUser": "Selecionar Usuário",
  "user": "Usuário",
  "reward": "Recompensa",
  "status": "Status",
  "date": "Data",
  "sendMessageTo": "Enviar mensagem para {{name}}",
  "openSidebar": "Abrir menu lateral",

  // User Management
  "userManagement": "Gerenciamento de Usuários",
  "allUsers": "Todos os Usuários",
  "searchUsers": "Buscar Usuários",
  "filterByCountry": "Filtrar por País",
  "minPoints": "Pontos Mín",
  "maxPoints": "Pontos Máx",
  "sortBy": "Ordenar por",
  "selectAll": "Selecionar Todos",
  "usersSelected": "usuários selecionados",
  "noUsersFound": "Nenhum usuário encontrado",
  "noUsers": "Nenhum usuário",
  "name": "Nome",
  "fullName": "Nome Completo",
  "email": "Email",
  "country": "País",
  "points": "Pontos",
  "totalPoints": "Total de Pontos",
  "waterVolume": "Volume de Água",
  "joinedDate": "Data de Registro",
  "actions": "Ações",
  "view": "Ver",
  "edit": "Editar",
  "delete": "Excluir",
  "editUser": "Editar Usuário",
  "deleteUser": "Excluir Usuário",
  "deleteUserConfirmation": "Tem certeza que deseja excluir {{name}}? Esta ação não pode ser desfeita.",
  "userDetails": "Detalhes do Usuário",
  "personalInfo": "Informações Pessoais",
  "statistics": "Estatísticas",
  "rewardRequests": "Solicitações de Recompensa",
  "completedSurveys": "Pesquisas Completadas",
  "noRewardRequests": "Nenhuma solicitação de recompensa",
  "noCompletedSurveys": "Nenhuma pesquisa completada",
  "userUpdated": "Usuário atualizado com sucesso",
  "errorUpdatingUser": "Erro ao atualizar usuário",
  "userDeleted": "Usuário excluído com sucesso",
  "errorDeletingUser": "Erro ao excluir usuário",
  "select": "Selecionar",

  // Survey Management
  "surveyManagement": "Gerenciamento de Pesquisas",
  "createSurvey": "Criar Pesquisa",
  "editSurvey": "Editar Pesquisa",
  "noSurveys": "Nenhuma pesquisa",
  "title": "Título",
  "description": "Descrição",
  "status": "Status",
  "active": "Ativo",
  "inactive": "Inativo",
  "questions": "Perguntas",
  "addQuestion": "Adicionar Pergunta",
  "question": "Pergunta",
  "questionText": "Texto da Pergunta",
  "options": "Opções",
  "addOption": "Adicionar Opção",
  "option": "Opção",
  "required": "Obrigatório",
  "multipleChoice": "Múltipla Escolha",
  "text": "Texto",
  "rating": "Avaliação",
  "boolean": "Sim/Não",
  "surveyCreated": "Pesquisa criada com sucesso",
  "errorCreatingSurvey": "Erro ao criar pesquisa",
  "surveyUpdated": "Pesquisa atualizada com sucesso",
  "errorUpdatingSurvey": "Erro ao atualizar pesquisa",
  "surveyDeleted": "Pesquisa excluída com sucesso",
  "errorDeletingSurvey": "Erro ao excluir pesquisa",
  "responses": "Respostas",
  "viewResponses": "Ver Respostas",
  "downloadCSV": "Baixar CSV",
  "noResponses": "Nenhuma resposta ainda",
  "anonymous": "Anônimo",

  // Reward Management
  "rewardManagement": "Gerenciamento de Recompensas",
  "createReward": "Criar Recompensa",
  "editReward": "Editar Recompensa",
  "noRewards": "Nenhuma recompensa",
  "pointsRequired": "Pontos Necessários",
  "photo": "Foto",
  "uploadPhoto": "Enviar Foto",
  "photoSelected": "Foto Selecionada",
  "messageTemplate": "Modelo de Mensagem de Aprovação",
  "approvalMessagePlaceholder": "Mensagem para enviar ao aprovar a solicitação de recompensa",
  "rewardCreated": "Recompensa criada com sucesso",
  "errorCreatingReward": "Erro ao criar recompensa",
  "rewardUpdated": "Recompensa atualizada com sucesso",
  "errorUpdatingReward": "Erro ao atualizar recompensa",
  "rewardDeleted": "Recompensa excluída com sucesso",
  "errorDeletingReward": "Erro ao excluir recompensa",

  // Advertisement Management
  "advertisementManagement": "Gerenciamento de Anúncios",
  "advertisements": "Anúncios",
  "createAdvertisement": "Criar Anúncio",
  "editAdvertisement": "Editar Anúncio",
  "noAdvertisements": "Nenhum anúncio",
  "advertisement": "Anúncio",
  "period": "Período",
  "frequency": "Frequência",
  "duration": "Duração",
  "startDate": "Data de Início",
  "endDate": "Data de Término",
  "minutes": "minutos",
  "seconds": "segundos",
  "everyXMinutes": "A cada {{minutes}} minutos",
  "xSeconds": "{{seconds}} segundos",
  "advertisementCreated": "Anúncio criado com sucesso",
  "errorCreatingAdvertisement": "Erro ao criar anúncio",
  "advertisementUpdated": "Anúncio atualizado com sucesso",
  "errorUpdatingAdvertisement": "Erro ao atualizar anúncio",
  "advertisementDeleted": "Anúncio excluído com sucesso",
  "errorDeletingAdvertisement": "Erro ao excluir anúncio",

  // Partner Offers Management
  "partnerOfferManagement": "Gerenciamento de Ofertas de Parceiros",
  "partnerOffers": "Ofertas de Parceiros",
  "createPartnerOffer": "Criar Oferta de Parceiro",
  "editPartnerOffer": "Editar Oferta de Parceiro",
  "noPartnerOffers": "Nenhuma oferta de parceiro",
  "partnerOfferCreated": "Oferta de parceiro criada com sucesso",
  "errorCreatingPartnerOffer": "Erro ao criar oferta de parceiro",
  "partnerOfferUpdated": "Oferta de parceiro atualizada com sucesso",
  "errorUpdatingPartnerOffer": "Erro ao atualizar oferta de parceiro",
  "partnerOfferDeleted": "Oferta de parceiro excluída com sucesso",
  "errorDeletingPartnerOffer": "Erro ao excluir oferta de parceiro",

  // Common
  "save": "Salvar",
  "cancel": "Cancelar",
  "close": "Fechar",
  "create": "Criar",
  "update": "Atualizar",
  "approve": "Aprovar",
  "reject": "Rejeitar",
  "pending": "Pendente",
  "approved": "Aprovado",
  "rejected": "Rejeitado",
  "translations": "Traduções",
  "primaryLanguage": "Idioma Principal",
  "copyQuestionsStructure": "Copiar Estrutura das Perguntas",
  "errorFetchingData": "Erro ao buscar dados",
  "pleaseAllFields": "Por favor preencha todos os campos",
  "language": "Idioma",
  "allCountries": "Todos os Países",
  "targetCountries": "Países alvo",
  "selectCountries": "Selecionar países",
  "leaveEmptyForAllCountries": "Deixe vazio para disponibilizar em todos os países",
  "surveys": "Pesquisas",
  "requestDate": "Data da Solicitação",
  "statusUpdated": "Status atualizado com sucesso",
  "errorUpdatingStatus": "Erro ao atualizar o status",
  "send": "Enviar",
  "errorFetchingRewards": "Erro ao buscar recompensas",
  "image": "Imagem",
  "uploadImage": "Enviar Imagem",
  "imageSelected": "Imagem Selecionada",
  "imageRequired": "A imagem é obrigatória",
  "imageUrl": "URL da imagem"
}
};